export enum DocumentType {
  CERTIFICATE = 'CERTIFICATE',
  DIPLOMA = 'DIPLOMA',
  COURSES_AND_TRAININGS = 'COURSES_AND_TRAININGS',
}
